import { TooltipComponent } from '@components/core/tooltip.component';
import { cn } from '@lib/utils';
import { CheckCircle2Icon, CircleAlertIcon, CircleSlashIcon } from 'lucide-react';
import type { FC } from 'react';
import type { MeiaTaskReadinessStatus } from './meia-task-column.util';

type MeiaTaskReadinessStatusIconProps = {
  className?: string;
  /** Accessible label prefix; defaults to the task-readiness wording. */
  label?: string;
  status: MeiaTaskReadinessStatus;
  tooltip: string;
};

const STATUS_ICON: Record<MeiaTaskReadinessStatus, { Icon: typeof CheckCircle2Icon; className: string }> = {
  complete: {
    Icon: CheckCircle2Icon,
    className: 'text-emerald-600',
  },
  empty: {
    Icon: CircleSlashIcon,
    className: 'text-red-500',
  },
  partial: {
    Icon: CircleAlertIcon,
    className: 'text-amber-500',
  },
};

export const MeiaTaskReadinessStatusIcon: FC<MeiaTaskReadinessStatusIconProps> = (props) => {
  const { className, label = 'Task readiness', status, tooltip } = props;
  const { Icon, className: iconClassName } = STATUS_ICON[status];

  return (
    <TooltipComponent
      side="top"
      trigger={
        <span
          aria-label={`${label}: ${status}`}
          className={cn('inline-flex shrink-0', className)}
        >
          <Icon className={cn('size-5', iconClassName)} />
        </span>
      }
    >
      {tooltip}
    </TooltipComponent>
  );
};
